/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { UpdateActions } from '../../../../../actions/universalTrackerValue';
import { UniversalTrackerValuePlain } from '../../../../../types/universalTrackerValue';
import { SubmitVerifiedButtonState, QuestionButtonTooltip } from '../../constants';
import { isUtrvCompletedOpen } from '@utils/universalTrackerValue';

export const canSubmitAndVerifyAction = ({ status }: Pick<UniversalTrackerValuePlain, 'status'>, action: number) => {
  const { UPDATED, REJECTED, VERIFIED } = UpdateActions.ACTION.UTR;
  switch (action) {
    case SubmitVerifiedButtonState.Show:
      return [REJECTED, UPDATED, VERIFIED].includes(status);
    case SubmitVerifiedButtonState.Enable:
      return [REJECTED, VERIFIED].includes(status);
    default:
      return false;
  }
}

export const getSubmitButtonTooltip = (
  { status, assuranceStatus }: Pick<UniversalTrackerValuePlain, 'status' | 'assuranceStatus'>,
  isDisabled: boolean,
  isContributorAndVerifier: boolean
) => {
  const { CREATED, UPDATED, REJECTED, VERIFIED } = UpdateActions.ACTION.UTR;
  if (!isDisabled) {
    return isContributorAndVerifier ? QuestionButtonTooltip.SubmitWithoutVerification : '';
  }
  if (isUtrvCompletedOpen({ assuranceStatus }) && isContributorAndVerifier) {
    return QuestionButtonTooltip.NoteRequiredOnRestatement;
  }
  switch (status) {
    case UPDATED:
      return isContributorAndVerifier ? QuestionButtonTooltip.UpdateToSubmit : QuestionButtonTooltip.NothingToSubmit;
    case VERIFIED:
      return isContributorAndVerifier ? QuestionButtonTooltip.NothingToSubmit : QuestionButtonTooltip.UnableToSubmit;
    case CREATED:
    case REJECTED:
    default:
      return QuestionButtonTooltip.NothingToSubmit;
  }
};

export const getVerifyButtonTooltip = (isDisabled: boolean) => {
  return isDisabled ? QuestionButtonTooltip.NothingToVerify : ''
}

export const getRejectButtonTooltip = (isDisabled: boolean) => {
  return isDisabled ? QuestionButtonTooltip.NoteRequiredOnRestatement : '';
};

export const getSubmitAndVerifyButtonTooltip = (
  { verificationRequired, assuranceStatus }: Pick<UniversalTrackerValuePlain, 'verificationRequired' | 'assuranceStatus'>,
  isDisabled: boolean,
) => {
  if (!isDisabled) {
    return verificationRequired ? QuestionButtonTooltip.SubmitAsVerification : '';
  }
  if (isUtrvCompletedOpen({ assuranceStatus })) {
    return QuestionButtonTooltip.NoteRequiredOnRestatement;
  }
  if (verificationRequired) {
    return QuestionButtonTooltip.NothingToSubmitOrVerify;
  }
  return QuestionButtonTooltip.NothingToSubmit;
};
